module.exports = __webpack_public_path__ + "static/media/Haley_Keglovits.53909ad1.png";